"use client";

import { c as _c } from "react/compiler-runtime";
import { formatDistanceToNow } from "date-fns";
import { enUS, zhCN } from "date-fns/locale";
import { Key, Copy, MoreVertical, Shield } from "lucide-react";
import { getFeatureDemoCopy } from "@/components/features/feature-demo-copy";
import { Badge } from "@/lib/components/badge";
import { Button } from "@/lib/components/button";
import { Card, CardContent, CardDescription, CardHeader, CardTitle } from "@/lib/components/card";
import { mockApiKeys } from "@/lib/mock-feature-data";
import { useI18n } from "@llmgateway/i18n/react";
export function ApiKeyDemo() {
  const $ = _c(29);
  const {
    locale
  } = useI18n();
  let t0;
  if ($[0] !== locale) {
    t0 = getFeatureDemoCopy(locale);
    $[0] = locale;
    $[1] = t0;
  } else {
    t0 = $[1];
  }
  const copy = t0.apiKey;
  const dateFnsLocale = locale === "zh-CN" ? zhCN : enUS;
  let t1;
  if ($[2] !== copy.title) {
    t1 = <CardTitle>{copy.title}</CardTitle>;
    $[2] = copy.title;
    $[3] = t1;
  } else {
    t1 = $[3];
  }
  let t2;
  if ($[4] !== copy.description) {
    t2 = <CardDescription>{copy.description}</CardDescription>;
    $[4] = copy.description;
    $[5] = t2;
  } else {
    t2 = $[5];
  }
  let t3;
  if ($[6] !== t1 || $[7] !== t2) {
    t3 = <CardHeader>{t1}{t2}</CardHeader>;
    $[6] = t1;
    $[7] = t2;
    $[8] = t3;
  } else {
    t3 = $[8];
  }
  let t4;
  if ($[9] !== copy.lastUsed || $[10] !== copy.names || $[11] !== copy.requests || $[12] !== copy.status || $[13] !== dateFnsLocale) {
    t4 = mockApiKeys.map(apiKey => <div key={apiKey.id} className="flex items-center justify-between p-4 rounded-lg border bg-card hover:shadow-md transition-shadow"><div className="flex items-center gap-4"><div className="p-2 rounded-lg bg-primary/10"><Key className="h-5 w-5 text-primary" /></div><div className="space-y-1"><div className="flex items-center gap-2"><p className="font-semibold">{copy.names[apiKey.name as keyof typeof copy.names] ?? apiKey.name}</p><Badge variant="outline" className="text-xs">{copy.status[apiKey.status as keyof typeof copy.status] ?? apiKey.status}</Badge></div><div className="flex items-center gap-3 text-sm text-muted-foreground"><code className="text-xs bg-muted px-2 py-1 rounded">{apiKey.keyPrefix}••••{apiKey.lastFour}</code><span>•</span><span>{apiKey.usageCount.toLocaleString()} {copy.requests}</span><span>•</span><span>{copy.lastUsed}{" "}{formatDistanceToNow(apiKey.lastUsed, {
                addSuffix: true,
                locale: dateFnsLocale
              })}</span></div></div></div><div className="flex items-center gap-2"><Button variant="ghost" size="icon"><Copy className="h-4 w-4" /></Button><Button variant="ghost" size="icon"><MoreVertical className="h-4 w-4" /></Button></div></div>);
    $[9] = copy.lastUsed;
    $[10] = copy.names;
    $[11] = copy.requests;
    $[12] = copy.status;
    $[13] = dateFnsLocale;
    $[14] = t4;
  } else {
    t4 = $[14];
  }
  let t5;
  if ($[15] === Symbol.for("react.memo_cache_sentinel")) {
    t5 = <Shield className="h-5 w-5 text-muted-foreground mt-0.5" />;
    $[15] = t5;
  } else {
    t5 = $[15];
  }
  let t6;
  if ($[16] !== copy.secureStorage) {
    t6 = <p className="font-medium">{copy.secureStorage}</p>;
    $[16] = copy.secureStorage;
    $[17] = t6;
  } else {
    t6 = $[17];
  }
  let t7;
  if ($[18] !== copy.secureStorageDescription) {
    t7 = <p className="text-sm text-muted-foreground">{copy.secureStorageDescription}</p>;
    $[18] = copy.secureStorageDescription;
    $[19] = t7;
  } else {
    t7 = $[19];
  }
  let t8;
  if ($[20] !== t6 || $[21] !== t7) {
    t8 = <div className="mt-6 p-4 rounded-lg border border-dashed border-muted-foreground/30 bg-muted/30"><div className="flex items-start gap-3">{t5}<div className="space-y-1">{t6}{t7}</div></div></div>;
    $[20] = t6;
    $[21] = t7;
    $[22] = t8;
  } else {
    t8 = $[22];
  }
  let t9;
  if ($[23] !== t4 || $[24] !== t8) {
    t9 = <CardContent><div className="space-y-4">{t4}{t8}</div></CardContent>;
    $[23] = t4;
    $[24] = t8;
    $[25] = t9;
  } else {
    t9 = $[25];
  }
  let t10;
  if ($[26] !== t3 || $[27] !== t9) {
    t10 = <Card>{t3}{t9}</Card>;
    $[26] = t3;
    $[27] = t9;
    $[28] = t10;
  } else {
    t10 = $[28];
  }
  return t10;
}